if (!customElements.get('peri-loop-player')) {
  customElements.define('peri-loop-player', class extends HTMLElement {
    connectedCallback() { requestAnimationFrame(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.visible = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.removeAttribute('autoplay');
      this.button.hidden = false;
      const update = () => {
        const playing = !this.video.paused;
        this.button.dataset.playing = String(playing);
        this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      };
      this.video.addEventListener('play', update, options);
      this.video.addEventListener('pause', update, options);
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.video.play().catch(update);
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.sync = () => {
        if (this.visible && !document.hidden && !this.reduced.matches && !this.userPaused) {
          this.video.play().catch(update);
        } else {
          this.video.pause();
        }
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.sync();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.sync, options);
      this.reduced.addEventListener('change', this.sync, options);
      update();
    }
    disconnectedCallback() {
      if (this.video) this.video.pause();
      if (this.observer) this.observer.disconnect();
      if (this.abort) this.abort.abort();
      this.initialized = false;
    }
  });
}
